import { createI18n } from "vue-i18n";
import en from "./en.json";
import zh from "./zh.json";

const messages = {
  en,
  zh,
};

// const INTL_DOMAIN = "desk.tencentcloud.com";

// const isIntlSite = window.location.hostname.endsWith(INTL_DOMAIN);
// const isIntlSite = true;

export const getBaseLang = () => {
  // if (!isIntlSite) return "zh";

  const baseLang = localStorage.getItem("lang") || "";
  const langList = ["zh", "en"];
  if (langList.includes(baseLang)) {
    return baseLang;
  }
  return "zh";
};

const i18n = createI18n({
  locale: getBaseLang(), // 设置默认语言
  fallbackLocale: getBaseLang(), // 设置回退语言
  messages,
});

export default i18n;
